import { useState, useEffect } from "react";
import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { blockText, wordCount } from "@lib/formatString";
import { CaptionInfo } from "./icons/CaptionInfo";
import styles from "./styles/caption.module.css";

export function Caption({ show = false, text }) {
  const { t } = useTranslation("productpage");
  const [showCaption, setShowCaption] = useState(show);

  if (!text || wordCount(text) <= 5) {
    return null;
  }

  const handleShowCaption = () => {
    setShowCaption(true);
  };

  useEffect(() => {
    setShowCaption(show);
  }, [show]);

  if (showCaption) {
    return (
      <div className={styles.caption}>
        <span className={styles.captionText}>{blockText(text)}</span>
      </div>
    );
  }

  return (
    <div className={styles.captionIcon} onClick={() => handleShowCaption()}>
      {t("Model info")}
    </div>
  );
}

Caption.propTypes = {
  show: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
};
